<template>
  <div class="cash-operations">
    <div
      v-for="(operation, index) in cashOperations"
      :key="operation.id || index"
      class="cash-operation"
      :class="getCashOperationClass(index)"
    >
      <button
        type="button"
        class="cash-operation__toggle"
        :aria-expanded="getAriaExpanded(index)"
        :aria-controls="`cash-operation-${_uid}-${index}`"
        @click="openCashOperation(index)"
      >
        <span class="cash-operation__heading">
          <span class="cash-operation__amount">{{ priceToFormat(operation.amount) }}</span>
          <span class="cash-operation__meta">{{ getCashOperationType(operation.operationType) }} · {{ getDate(operation.createdAt) }}</span>
        </span>
        <span class="cash-operation__indicator" aria-hidden="true">
          <span
            class="cash-operation__arrow"
            :class="getCashOperationArrowClass(index)"
          />
        </span>
      </button>

      <div
        v-show="isShow(index)"
        :id="`cash-operation-${_uid}-${index}`"
        class="cash-operation__details"
      >
        <p>
          <span>Сумма</span><strong>{{ priceToFormat(operation.amount) }}</strong>
        </p>

        <p>
          <span>Тип</span>
          <strong>{{ getDataOperationType(operation.dataOperationType) }}</strong>
        </p>

        <p>
          <span>Дата</span>
          <strong>{{ getDate(operation.createdAt) }}</strong>
        </p>

        <p class="cash-operation__description">
          <span>Описание</span>
          <strong>{{ operation.description || '—' }}</strong>
        </p>

        <div class="actions">
          <button
            type="button"
            class="action-button modal-button--cancel"
            @click="removeOperation(operation)"
          >
            Удалить
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { priceToFormat } from '@/helper'
import moment from 'moment'

export default {
  name: 'RepairCashOperations',
  props: {
    repairId: {
      type: String,
      default: ''
    },
    cashOperations: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      openedOpenedOperation: null
    }
  },
  computed: {
    ...mapGetters('settings', ['getDefaultValues'])
  },
  methods: {
    ...mapActions('repairCashOperation', ['remove']),
    ...mapActions('modal', ['closeModal']),
    priceToFormat,
    getCashOperationClass (index) {
      return { 'cash-operation--open': this.openedOpenedOperation === index }
    },
    getAriaExpanded (index) {
      return this.openedOpenedOperation === index ? 'true' : 'false'
    },
    openCashOperation (index) {
      this.openedOpenedOperation = this.openedOpenedOperation === index ? null : index
    },
    getCashOperationArrowClass (index) {
      return { 'cash-operation__arrow--open': this.openedOpenedOperation === index }
    },
    getCashOperationType (type) {
      return this.getDefaultValues['cash-operation']?.find(({ code }) => code === type)?.name || ''
    },
    getDataOperationType (type) {
      return this.getDefaultValues['data-operation-type']?.find(({ code }) => code === type)?.name || ''
    },
    isShow (index) {
      return this.openedOpenedOperation === index
    },
    getDate (value) {
      return value ? moment(value).format('DD.MM.YYYY') : '—'
    },
    async removeOperation ({ id }) {
      const { error } = await this.remove({
        repairId: this.repairId,
        operationId: id,
      })

      if (error) {
        this.$notify({
          type: 'error',
          title: 'Ошибка при удалении',
          text: 'Произошла ошибка при удалении операции. Повторите попытку позже!',
          clean: false,
          duration: 3000
        })

        return
      }

      this.$notify({
        type: 'success',
        title: 'Ура!',
        text: 'Операция успешно удалена!',
        clean: false,
        duration: 3000
      })

      await this.closeModal(null)
    }
  }
}
</script>

<style lang="scss" src="./style.scss" scoped />
